import {DOCUMENT,isPlatformBrowser} from '@angular/common';
import {InjectionToken,PLATFORM_ID,inject} from '@angular/core';
import {environment} from '../../../environments/environment';
import {loadScript} from '../load-script';
import {ConsentService} from '../consent/consent.service';

const PIXEL_SRC='https://static.ads-twitter.com/uwt.js';

export interface Twq{(...args:unknown[]):void;queue?:unknown[];exe?:(...args:unknown[])=>void;version?:string}

export const X_PIXEL=new InjectionToken<()=>Promise<Twq|null>>('x.pixel',{
	providedIn:'root',
	factory:()=>{
		const isBrowser=isPlatformBrowser(inject(PLATFORM_ID));
		const document=inject(DOCUMENT);
		const consent=inject(ConsentService);
		let pending:Promise<Twq|null>|null=null;
		return ():Promise<Twq|null>=>{
			if(!isBrowser||!environment.x.pixelId||!consent.marketing()){
				return Promise.resolve(null);
			}
			pending??=(():Promise<Twq|null>=>{
				const window=document.defaultView;
				if(!window) return Promise.resolve(null);
				const twq:Twq=window.twq ?? Object.assign(
					function(...args:unknown[]):void{
						const self=window.twq as Twq;
						if(self.exe) self.exe(...args);
						else self.queue?.push(args);
					} as Twq,
					{queue:[] as unknown[],version:'1.1'}
				);
				window.twq??=twq;
				twq('config',environment.x.pixelId);
				return loadScript(document,PIXEL_SRC).then(():Twq=>twq);
			})();
			return pending;
		};
	}
});
